import React, { useState } from 'react';
import {
  Button,
  Card,
  CardFooter,
  CardSection,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  Layout,
  LayoutItem,
  Paragraph,
  SmallHeader,
} from '@axiom/ui';
import type { Account, User } from '@axiom/validation';

import StandingGroup from '../../public/svg/standing-group.svg';

import { MyBenchAskHowModal } from './MyBenchAskHowModal';

export type MyBenchEmptyProps = {
  account: Account;
  user: User;
};

export const MyBenchEmpty = ({ account, user }: MyBenchEmptyProps) => {
  const [askHowModal, setAskHowModal] = useState(false);
  const handleAskHowClick = () => {
    setAskHowModal(true);
  };

  return (
    <>
      <Grid name="EMPTY_BENCH">
        <GridRow>
          <GridColumn>
            <Card>
              <CardSection divider>
                <Layout>
                  <LayoutItem rightGutter="24px">
                    <StandingGroup data-test="SVG" height="77" width="77" />
                  </LayoutItem>
                  <LayoutItem>
                    <SmallHeader name="EMPTY_BENCH_HEADER">
                      Looks like your bench is empty
                    </SmallHeader>
                    <Gutter bottom="16px" />
                    <Paragraph name="EMPTY_BENCH_BODY_COPY">
                      Fill it with Axiom Talent that you trust.
                    </Paragraph>
                  </LayoutItem>
                </Layout>
              </CardSection>
              <CardFooter>
                <Button name="ASK_HOW" onClick={handleAskHowClick}>
                  Ask us how
                </Button>
              </CardFooter>
            </Card>
          </GridColumn>
        </GridRow>
      </Grid>
      {askHowModal ? (
        <MyBenchAskHowModal
          account={account}
          user={user}
          onClose={() => {
            setAskHowModal(false);
          }}
        />
      ) : null}
    </>
  );
};
